var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"phone"},[_vm._v("智慧服务热线：400-900-1408")])])
}]

export { render, staticRenderFns }